/**
 * 阅读进度条 Unpoly 组件
 *
 * 将进度条的生命周期与 article 元素绑定。
 * 当文章页面被渲染时，该编译器会激活进度条，并在页面卸载或离开时清理资源。
 */
export class ReadingProgress {
  static compiler(selector: string) {
    up.compiler(selector, () => {
      // 从 DOM 中获取顶部的进度条容器
      const progressBarContainer = document.getElementById("reading-progress");
      if (!progressBarContainer) return;

      const progressBar = progressBarContainer.querySelector(
        ".reading-progress-bar",
      ) as HTMLElement;
      if (!progressBar) return;

      let scrollableHeight = 0;
      let ticking = false;

      // 重新计算可滚动高度
      const refreshDimensions = () => {
        const docHeight = document.documentElement.scrollHeight;
        const winHeight = document.documentElement.clientHeight;
        scrollableHeight = docHeight - winHeight;
      };

      // 更新进度条百分比
      const updateProgress = () => {
        if (scrollableHeight <= 0) {
          progressBar.style.width = "0%";
          return;
        }
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const percent = Math.min(
          100,
          Math.max(0, (scrollTop / scrollableHeight) * 100),
        );
        progressBar.style.width = `${percent}%`;
      };

      // 滚动事件处理 (RAF 防抖优化)
      const handleScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          updateProgress();
          ticking = false;
        });
      };

      // 窗口变动重新计算高度
      const handleResize = () => {
        refreshDimensions();
        updateProgress();
      };

      // 显示进度条
      progressBarContainer.classList.remove("opacity-0");
      progressBarContainer.removeAttribute("aria-hidden");

      // 在下一次宏任务计算尺寸，确保 DOM 已经完全渲染并展开
      setTimeout(() => {
        refreshDimensions();
        updateProgress();
      }, 100);

      document.body.addEventListener("scroll", handleScroll, { passive: true });
      document.body.addEventListener("resize", handleResize, { passive: true });

      // Fallback 监听 window scroll/resize（某些布局下 scroll 可能在 window 出发）
      window.addEventListener("scroll", handleScroll, { passive: true });
      window.addEventListener("resize", handleResize, { passive: true });

      return () => {
        // 清理并隐藏状态
        progressBarContainer.classList.add("opacity-0");
        progressBarContainer.setAttribute("aria-hidden", "true");
        progressBar.style.width = "0%";

        document.body.removeEventListener("scroll", handleScroll);
        document.body.removeEventListener("resize", handleResize);
        window.removeEventListener("scroll", handleScroll);
        window.removeEventListener("resize", handleResize);
      };
    });
  }
}
